export default __webpack_public_path__ + "static/lozenge-dropdown-do-1-light-a79b338c04bd7b58cf8ce1bc5cefef0ed1d5716092d946728eb10b523775d726.png";